// Animated grey placeholder for loading states. Uses the .skeleton class
// from index.css (shimmer keyframe). Pair with composable wrappers (e.g.
// SkeletonCard, SkeletonRow) when you need a specific shape.

export function Skeleton({ width = '100%', height = 20, style = {} }) {
  return (
    <div className="skeleton" style={{ width, height, ...style }} />
  )
}

// Card-shaped skeleton matching .card/.group-card geometry — used in
// GamesTab / GroupsTab while data is loading.
export function SkeletonCard({ height = 88 }) {
  return (
    <div className="card" style={{ marginBottom: 8, padding: 14 }}>
      <Skeleton height={12} width="40%" style={{ marginBottom: 10 }} />
      <Skeleton height={height - 36} />
    </div>
  )
}

export function SkeletonList({ count = 4 }) {
  return (
    <div>
      {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} />)}
    </div>
  )
}
